<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br_tbl_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.br_tbl_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.br_label {
    color: rgba(0, 0, 0, 0.6);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    padding-bottom: 16px;
}

.br_section {
    padding-bottom: 16px;
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.v-label {
    font-size: 20px;
}

.msg_ok {
    color: rgba(0, 200, 0);
}

.msg_err {
    color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div class="ipoe_settings">
        <div>
            <ipv6_pool_box v-model="show_ipv6_ia_na_pool_form"
                @canceled="ipv6_pool_ia_na_form__on_cancel" 
                @selected="ipv6_pool_ia_na_form__on_select($event)">
            </ipv6_pool_box>
            <ipv6_pool_box v-model="show_ipv6_ia_pd_pool_form"
                @canceled="ipv6_pool_ia_pd_form__on_cancel" 
                @selected="ipv6_pool_ia_pd_form__on_select($event)">
            </ipv6_pool_box>
        </div>

        <div class="br_section"><h2 class="br">IPoE settings</h2></div>
        <ValidationObserver ref="observer" v-slot="{ invalid }">

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ipoe_ttl"
                    label="IPoE subscriber session TTL, sec (sysctl 'ipoe_ttl')"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <div class="br_label">
                Install subscriber routes, boolean (sysctl 'install_subsc_routes')
                <treeselect
                    v-model="settings.install_subsc_routes"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>

            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ipoe_subsc_passwd"
                    label="Subscriber RADIUS password (sysctl 'ipoe_subsc_passwd')"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>   

            <v-text-field
                v-model="settings.ia_na_pool"
                label="IPv6 IA NA pool">
                <template #append>
                    <v-btn @click="ipv6_pool_ia_na_form__show()">...</v-btn>
                </template>
            </v-text-field>

            <v-text-field
                v-model="settings.ia_pd_pool"
                label="IPv6 IA PD pool">
                <template #append>
                    <v-btn @click="ipv6_pool_ia_pd_form__show()">...</v-btn>
                </template>
            </v-text-field>

            <div class="br_label">
                DHCPv6 IA NA
                <treeselect
                    v-model="settings.ipoe_dhcpv6_ia_na"
                    :multiple="false" 
                    :options="dhcpv6_ia_options"
                />
            </div>

            <div class="br_label">
                DHCPv6 IA PD
                <treeselect
                    v-model="settings.ipoe_dhcpv6_ia_pd"
                    :multiple="false" 
                    :options="dhcpv6_ia_options"
                />
            </div>

            <div class="br_label">
                Initiate sessions by ingress packets (sysctl 'subsc_initiate_by_ingress_pkts')
                <treeselect
                    v-model="settings.subsc_initiate_by_ingress_pkts"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>

            <div class="br_label">
                Initiate sessions by egress packets (sysctl 'subsc_initiate_by_egress_pkts')
                <treeselect
                    v-model="settings.subsc_initiate_by_egress_pkts"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>            

            <div class="br_label">
                Initiate sessions by DHCP (sysctl 'l2_subsc_initiate_by_dhcp')
                <treeselect
                    v-model="settings.l2_subsc_initiate_by_dhcp"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>  

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ipoe_mac_acl_ttl"
                    label="IPoE MAC ACL TTL, sec (sysctl 'ipoe_mac_acl_ttl')"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.subsc_initiation_denied_timeout"
                    label="Session denied timeout, sec (sysctl 'subsc_initiation_denied_timeout')"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>
            
            <v-toolbar flat>
                <span class="msg_ok">{{ ok_msg_text }}</span>
                <span class="msg_err">{{ err_msg_text }}</span>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel()">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="save()">
                    Save</v-btn>
             </v-toolbar>            
        </ValidationObserver>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ip_pool_box from "../components/ip_pool_box.vue";
import ipv6_pool_box from "../components/ipv6_pool_box.vue";
import "../validation_rules.js"

export default {
    name: 'ipoe_settings',
    components: { 
        ValidationObserver, ValidationProvider, Treeselect, ip_pool_box, ipv6_pool_box
    },

    data: () => ({
        nb_vars: 0,
        var_ind: 0,

        show_ip_pool_form: false,

        show_ipv6_ia_na_pool_form: false,
        show_ipv6_ia_pd_pool_form: false,
        show_ipv6_slaac_pool_form: false,

        ip_pool_name: '',
        ip_pool_index: -1,
        new_ip_pool_dialog: false,
        ipoe_ipv4_pools: [],
        ipoe_ipv4_pools_hdrs: [
            { text: 'pool name', value: 'pool_name', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        ok_msg_text: "",
        err_msg_text: "",

        on_off_options: [
          {
            id: '0',
            label: 'Off',
          },
          {
            id: '1',
            label: 'On',
          },
        ],

        dhcpv6_ia_options: [
          {
            id: '0',
            label: 'Off',
          },
          {
            id: '1',
            label: 'Allocate by request',
          },
          {
            id: '2',
            label: 'Allways allocate',
          },
        ],

        settings: {},
        old_settings: {},
    }),

    created() {
        this.initialize();
    },

    methods: {
        clear_msgs() {
            this.ok_msg_text = "";
            this.err_msg_text = "";
        },

        on_off_str(val) {
            if (val == 1) {
                return "On";
            }

            return "Off";
        },

        settings_calc_fields() {
            this.old_settings = Object.assign({}, this.settings);
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.run_get_query('/ipoe/settings')
                .then(response => {
                    this.settings = response.data;
                    this.settings_calc_fields();                  
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        save() {
            this.clear_msgs();
            this.nb_vars = Object.keys(this.settings).length;
            this.var_ind = 0;
            this.save_cb();
        },

        on_save_completed() {
            this.err_msg_text = "";
            this.ok_msg_text = "IPoE settings have been successfully updated";
            this.settings_calc_fields();
            setTimeout(this.clear_msgs, 3000);
        },

        save_cb() {
            let key = Object.keys(this.settings)[this.var_ind];
            this.var_ind = this.var_ind + 1;
            let url = "";
            let data = {};

            if (this.old_settings[key] !== this.settings[key]) {
                switch (key) {
                case "ipoe_ttl":
                case "install_subsc_routes":
                case "ipoe_dhcpv6_ia_na":
                case "ipoe_dhcpv6_ia_pd":
                case "subsc_initiate_by_ingress_pkts":
                case "subsc_initiate_by_egress_pkts":
                case "l2_subsc_initiate_by_dhcp":
                case "ipoe_mac_acl_ttl":
                case "subsc_initiation_denied_timeout":
                    url = "/sysctl/set";
                    data["var_name"] = key;
                    data["value"] = this.settings[key];
                    break;

                case "ipoe_subsc_passwd":
                url = "/sysctl/set";
                    data["var_name"] = key;
                    data["value"] = '"' + this.settings[key] + '"';
                    break;

                case "ia_na_pool":
                    data["pool_type"] = "ia_na";
                    if (this.settings[key].trim() === '') {
                        url = "/ipoe/disable_ipv6_pool";
                    }
                    else {
                        url = "/ipoe/set_ipv6_pool";
                        data["pool_name"] = this.settings[key];
                    }
                    break;
                case "ia_pd_pool":
                    data["pool_type"] = "ia_pd";
                    if (this.settings[key].trim() === '') {
                        url = "/ipoe/disable_ipv6_pool";
                    }
                    else {
                        url = "/ipoe/set_ipv6_pool";
                        data["pool_name"] = this.settings[key];
                    }
                    break;
                };

                if (url !== "") {
                    api_client.run_post_query(url, data)
                    .then(response => {
                        if (response.data.hasOwnProperty("err_msg")) {
                            this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                        }
                        else {
                            if (this.var_ind == this.nb_vars) {
                                this.on_save_completed();
                            }
                            else {
                                this.save_cb();
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.$fire({title: "Command failed", text: error, type: "warning"});
                    });
                    
                    return;
                }
            }

            if (this.var_ind == this.nb_vars) {
                this.on_save_completed();
            }
            else {
                this.save_cb(); 
            }
        },

        cancel() {
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
            this.clear_msgs();
            this.initialize();
        },

        /* ipv6 box ia na */
        ipv6_pool_ia_na_form__show() {
            this.show_ipv6_ia_na_pool_form = true;
        },

        ipv6_pool_ia_na_form__on_cancel() {
            this.show_ipv6_ia_na_pool_form = false;
        },

        ipv6_pool_ia_na_form__on_select(ipv6_pool_name) {
            this.settings["ia_na_pool"] = ipv6_pool_name;
            this.show_ipv6_ia_na_pool_form = false;
        },        

        /* ipv6 box ia pd */
        ipv6_pool_ia_pd_form__show() {
            this.show_ipv6_ia_pd_pool_form = true;
        },

        ipv6_pool_ia_pd_form__on_cancel() {
            this.show_ipv6_ia_pd_pool_form = false;
        },

        ipv6_pool_ia_pd_form__on_select(ipv6_pool_name) {
            this.settings["ia_pd_pool"] = ipv6_pool_name;
            this.show_ipv6_ia_pd_pool_form = false;
        },
    }
};
</script>
